import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'reclamos-medios-no-magneticos',
  templateUrl: './reclamos-medios-no-magneticos.component.html',
  styleUrls: ['./reclamos-medios-no-magneticos.component.scss'],
})
export class ReclamosMediosNOMagneticos implements OnInit {
  form: FormGroup;
  @Input() data: { task: any };
  analista: string;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    console.log('Task values', task);
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      nombre_cliente: [
        values ? values.nombre_cliente : '',
        [Validators.required],
      ],
      ci_rif_pasaporte: [
        values ? values.ci_rif_pasaporte : '',
        [Validators.required],
      ],
      numero_cuenta: [values ? values.numero_cuenta : this.analista],
      numero_sake: [values ? values.numero_sake : ''],
      fecha_inicio: [values ? values.fecha_inicio : '', [Validators.required]],
      fecha_fin: [values ? values.fecha_fin : '', [Validators.required]],
      total_monto_reclamado: [
        values ? values.total_monto_reclamado : '',
        [Validators.required],
      ],
      total_numero_tx_reclamadas: [
        values ? values.total_numero_tx_reclamadas : '',
        [Validators.required],
      ],
      medio_magenetico: [
        values ? values.medio_magenetico : '',
        [Validators.required],
      ],
      numero_medio: [values ? values.numero_medio : '', [Validators.required]],
      fecha_ultimo_uso: [
        values ? values.fecha_ultimo_uso : '',
        [Validators.required],
      ],
      fecha_bloqueo: [
        values ? values.fecha_bloqueo : '',
        [Validators.required],
      ],
      descripcion_hechos: [
        values ? values.descripcion_hechos : '',
        [Validators.required],
      ],
      alerta_monitoreo: [
        values ? values.alerta_monitoreo : '',
        [Validators.required],
      ],
      gestion_alerta: [
        values ? values.gestion_alerta : '',
        [Validators.required],
      ],
      notificacion_sms: [
        values ? values.notificacion_sms : '',
        [Validators.required],
      ],
      tipificacion_reclamo: [
        values ? values.tipificacion_reclamo : '',
        [Validators.required],
      ],
      analisis_gerencia_deteccion: [
        values ? values.analisis_gerencia_deteccion : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
